import { render, staticRenderFns } from "./DashboardOs.vue?vue&type=template&id=0634caff&scoped=true&"
import script from "./DashboardOs.vue?vue&type=script&lang=ts&"
export * from "./DashboardOs.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardOs.vue?vue&type=style&index=0&id=0634caff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0634caff",
  null
  
)

export default component.exports